import { Link } from 'react-router-dom';
import { contactPath } from '../../constants/navigation';

export function FloatingContact() {
  return (
    <div className="fixed bottom-24 right-6 z-40 flex flex-col gap-3">
      <Link
        to="/inquiry"
        className="group flex items-center gap-2 bg-gradient-to-r from-primary to-secondary text-white pl-4 pr-5 py-3 rounded-full shadow-lg shadow-purple-500/40 hover:scale-105 transition-transform"
        aria-label="购买咨询"
      >
        <i className="fa fa-shopping-cart" />
        <span className="text-sm font-medium max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-300 whitespace-nowrap">
          购买咨询
        </span>
      </Link>
      <Link
        to={contactPath('business')}
        className="group flex items-center justify-center w-12 h-12 bg-darker/90 backdrop-blur-md border border-purple-500/30 text-secondary rounded-full hover:bg-white/10 hover:scale-105 transition-all"
        aria-label="商务合作"
      >
        <i className="fa fa-handshake-o" />
      </Link>
    </div>
  );
}
